import React from 'react';
import { XStack, YStack } from 'tamagui';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { LinearGradient } from 'tamagui/linear-gradient';

// Configure dayjs plugins
dayjs.extend(utc);
dayjs.extend(timezone);

import { GroupGathering } from '../../store/groupDetailSlice';
import { CobuText } from '@cobu/ui';
import { formatDateTime } from '../../utils/dateTime';
import { Strings } from '../../constants/Strings';

interface GroupGatheringCardProps {
    gathering: GroupGathering;
    onPress: () => void;
    showPastIndicator?: boolean;
}

export const GroupGatheringCard: React.FC<GroupGatheringCardProps> = ({
    gathering,
    onPress,
}) => {

    const formatDate = (dateString: string) => {
        return formatDateTime(dateString, gathering.buildingTimezone || 'UTC', 'dddd [- at] LT');
    };

    const shadowStyle = {
        shadowOffset: { width: 0, height: 2 },
        shadowOpacity: 1,
        shadowRadius: 3,
        elevation: 5,
        shadowColor: '$borderColor'
    };

    const gradientStyle = {
        borderTopLeftRadius: 8,
        borderBottomLeftRadius: 8,
        justifyContent: 'center' as const,
        alignItems: 'center' as const,
        padding: 10,
    minWidth: 70,
    // Ensure the gradient block is always visible and readable
    flexShrink: 0,
    backgroundColor: '$cobuPink',
    };


    return (
        <XStack
            onPress={onPress}
            br="$2"
            bc="$white"
            boc="$red"
            style={shadowStyle}
        >
            {/* Date Container with Gradient Background and Text on Top */}
            <YStack style={{ ...gradientStyle, position: 'relative' as const }}>
                <LinearGradient
                    colors={['$cobuPink', '$cobuDarkBlue']}
                    start={{ x: 0, y: 1 }}
                    end={{ x: 1, y: 0 }}
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        borderTopLeftRadius: 8,
                        borderBottomLeftRadius: 8,
                    }}
                />
                <CobuText
                    variant="subheading"
                    color="$white"
                    ta="center"
                    zi={1}
                >
                    {dayjs.utc(gathering.scheduledStartTime)
                        .tz(gathering.buildingTimezone || 'UTC')
                        .format("MMM")
                        .toUpperCase()}
                </CobuText>
                <CobuText
                    variant="subheading"
                    color="$white"
                    ta="center"
                    zi={1}
                >
                    {dayjs.utc(gathering.scheduledStartTime)
                        .tz(gathering.buildingTimezone || 'UTC')
                        .format('D')}
                </CobuText>
            </YStack>

            {/* Details Container */}
            <YStack
                pl={18}
                pr={10}
                py={15}
            >
                <CobuText
                    variant="subheading"
                    color="$color"
                    mb="$2"
                >
                    {gathering.title}
                </CobuText>

                <CobuText
                    variant="body"
                    color="$color"
                    mb="$3"
                >
                    {gathering.locationString || Strings.get().events.detail.labels.locationTBD}
                </CobuText>

                <CobuText
                    variant="body"
                    fos="$2"
                >
                    {formatDate(gathering.scheduledStartTime)}
                </CobuText>
            </YStack>
        </XStack>
    );
}; 